import { render, staticRenderFns } from "./ChangeRequestEditView.vue?vue&type=template&id=1b71bff2&"
import script from "./ChangeRequestEditView.vue?vue&type=script&lang=js&"
export * from "./ChangeRequestEditView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports